import { DjangoUser, parseUser, User } from './../user';
import { PROPOSAL_REGISTRATION_STATUS } from './proposal-registration-status.model';

export class ProposalRegistration {
  id: string;
  employerStaffUser: User;
  description: string;
  status: PROPOSAL_REGISTRATION_STATUS;
  levecapitalUser: string;

  constructor(data: string | ProposalRegistration | DjangoProposalRegistration = {}) {
    if (typeof data === 'string') {
      bindConstructorDataToInstance(this, { id: data });
    } else {
      bindConstructorDataToInstance(this, data);
    }
  }
}

export interface DjangoProposalRegistration {
  id?: string;
  employer_staff_user_id?: string | DjangoUser;
  description?: string;
  status?: PROPOSAL_REGISTRATION_STATUS;
  levecapital_user?: string;
}

export function parseProposalRegistration(
  data: string | DjangoProposalRegistration | ProposalRegistration,
) {
  if (data) {
    return new ProposalRegistration(data);
  } else {
    return undefined;
  }
}

///////////////
/// PRIVATE ///
///////////////
function bindConstructorDataToInstance(
  instance: ProposalRegistration,
  data: ProposalRegistration | DjangoProposalRegistration,
) {
  const jsData = bindDjangoPropsToJs(data) as ProposalRegistration;
  instance.id = jsData.id;
  instance.employerStaffUser = parseUser(jsData.employerStaffUser);
  instance.description = jsData.description;
  instance.status = jsData.status;
  instance.levecapitalUser = jsData.levecapitalUser;
}

function bindDjangoPropsToJs(data: ProposalRegistration | DjangoProposalRegistration) {
  const djangoData = data as DjangoProposalRegistration;
  const jsData = data as ProposalRegistration;
  return {
    ...data,
    employerStaffUserId: djangoData.employer_staff_user_id || jsData.employerStaffUser,
    levecapitalUser: djangoData.levecapital_user || jsData.levecapitalUser,
  };
}
